import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const Container: React.FC<ContainerProps> = ({ children, className = '' }) => {
  // max-width 1200px (content approx 1120px)
  return (
    <div className={`mx-auto max-w-[1120px] px-4 md:px-6 w-full ${className}`}>{children}</div>
  );
};
